var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloudDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5713 6.4429C11.3557 6.17336 10.9624 6.12966 10.6928 6.34529L9.62496 7.19959V4.33333C9.62496 3.98815 9.34514 3.70833 8.99996 3.70833C8.65478 3.70833 8.37496 3.98815 8.37496 4.33333V7.19963L7.30704 6.34529C7.0375 6.12966 6.64419 6.17336 6.42856 6.4429C6.21293 6.71243 6.25663 7.10574 6.52617 7.32137L8.60725 8.98624C8.71457 9.07302 8.85119 9.125 8.99996 9.125C9.15 9.125 9.2877 9.07212 9.39543 8.98399L11.4737 7.32137C11.7432 7.10574 11.7869 6.71243 11.5713 6.4429Z",
    fill: "#2246DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.05028 2.06989C6.8358 0.856115 8.20222 0.0514603 9.75754 0.0514603C12.1023 0.0514603 14.0199 1.88021 14.162 4.18923C14.2088 4.18745 14.2558 4.18655 14.303 4.18655C16.3218 4.18655 17.9583 5.82308 17.9583 7.84185C17.9583 9.86062 16.3218 11.4972 14.303 11.4972L4.83329 11.4972C2.18693 11.4972 0.041626 9.35185 0.041626 6.70548C0.041626 4.05912 2.18693 1.91382 4.83329 1.91382C5.25322 1.91382 5.66119 1.96798 6.05028 2.06989ZM9.75754 1.30146C8.50332 1.30146 7.41838 2.03144 6.90668 3.09251C6.76497 3.38635 6.4211 3.52178 6.11707 3.40348C5.71987 3.24892 5.28727 3.16382 4.83329 3.16382C2.87728 3.16382 1.29163 4.74948 1.29163 6.70548C1.29163 8.66149 2.87728 10.2472 4.83329 10.2472L14.3022 10.2472C15.6306 10.2472 16.7083 9.17026 16.7083 7.84185C16.7083 6.51344 15.6314 5.43655 14.303 5.43655C14.0868 5.43655 13.8782 5.46491 13.6803 5.51777C13.4801 5.57124 13.2665 5.52202 13.1098 5.38638C12.9532 5.25074 12.874 5.04629 12.8983 4.84054C12.9129 4.71741 12.9204 4.59188 12.9204 4.46434C12.9204 2.71753 11.5043 1.30146 9.75754 1.30146Z",
    fill: "#2246DC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDownloadIcon);
export default __webpack_public_path__ + "static/media/cloud-download-icon.33ebdcf2bca498f19f1ad4e9d64f9c66.svg";
export { ForwardRef as ReactComponent };